import { jsxs as d, jsx as e } from "react/jsx-runtime";
import i from "../../utils/colors.js";
import { f as s } from "../../styled-qu50FBLM.mjs";
import { Svg as f, Title as m, GElement as p, Path as L } from "./Elements.js";
const x = ({
  className: o = "",
  width: r = 35,
  height: t = 22,
  viewBox: a = "0 0 35 22",
  fill: n = i.orange,
  focusable: l
}) => /* @__PURE__ */ d(
  f,
  {
    className: o,
    width: r,
    height: t,
    viewBox: a,
    "aria-labelledby": "Upload",
    $cssHelper: s,
    focusable: !!l,
    "aria-hidden": !l,
    children: [
      /* @__PURE__ */ e(m, { text: "Upload" }),
      /* @__PURE__ */ e(
        p,
        {
          id: "Icon/Upload",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          children: /* @__PURE__ */ e(
            L,
            {
              fill: n,
              fillRule: "nonzero",
              d: "M28.21875,8.17523437 C27.2270833,3.50560547 22.8083333,0 17.5,0 C13.2854167,0 9.625,2.21976562 7.80208333,5.46820312 C3.4125,5.90132812 0,9.35279297 0,13.5351562 C0,18.015293 3.92291667,21.65625 8.75,21.65625 L27.7083333,21.65625 C31.7333333,21.65625 35,18.624375 35,14.8886719 C35,11.3153906 32.0104167,8.41886719 28.21875,8.17523437 Z M20,11.84375 L20,16.84375 L15,16.84375 L15,11.84375 L11.9636072,11.84375 L17.5,5.4140625 L23.0287553,11.84375 L20,11.84375 Z",
              transform: "translate(17.500000, 10.828125) scale(-1, 1) translate(-17.500000, -10.828125)"
            }
          )
        }
      )
    ]
  }
);
export {
  x as default
};
